module.exports = __webpack_public_path__ + "static/img/jsgs.8750f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/jsgs.jpg
// module id = Z933
// module chunks = 1